export default () => ({
  trigger: {
    name: 'insurance_information.click_to_ombudsman_information',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'ombudsman',
      },
    },
    nonInt: true,
  },
});
